module.exports = __webpack_public_path__ + "img/generation_classic.0f72a005.png";